import { render } from "./RegisterPhase.vue?vue&type=template&id=ebc50a96&scoped=true"
import script from "./RegisterPhase.vue?vue&type=script&lang=js"
export * from "./RegisterPhase.vue?vue&type=script&lang=js"

import "@/assets/scss/_register-phase.scss?vue&type=style&index=0&id=ebc50a96&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc50a96"]])

export default __exports__